import { getStore } from "store";

export default function (nextState, replace, callback) {
    const { scope } = getStore().getState();
    const { pathname, query } = nextState.location;

    if (
        pathname === `/brand/${scope.brand._id}/management/permissions` &&
        !scope?.brand?.preferences.get("use_new_permissions")
    ) {
        window.location.href = `/brand/${scope.brand._id}/management?vp=permissionsmanagement`;
    } else if (
        pathname === `/brand/${scope.brand._id}/management` &&
        query.vp === "permissionsmanagement" &&
        scope?.brand?.preferences.get("use_new_permissions")
    ) {
        replace({
            pathname: `/brand/${scope.brand._id}/management/permissions`,
        });
    }

    callback();
}
